module.exports = __webpack_public_path__ + "img/ruanzhu1919.ded19050.png";